import { MessageType } from "@opstel/query/v2/models/bannerMessage";
import { TractieMessageBarProps } from "@tractie/components/custom-elements";
import { useBannerMessageQuery } from "./useBannerMessageQuery";

const messageTypeMap: Record<MessageType, TractieMessageBarProps["situation"] | undefined> = {
  Warning: "warning",
  Info: "info",
  None: undefined,
};

export function DisruptionMessageBanner(): React.JSX.Element | null {
  const { data: bannerMessage } = useBannerMessageQuery();

  if (!bannerMessage || bannerMessage.messageType === "None") {
    return null;
  }

  return (
    <tractie-message-bar
      dismissible
      situation={messageTypeMap[bannerMessage.messageType]}
      text={bannerMessage.bannerMessage}
      data-testid="message-banner"
    ></tractie-message-bar>
  );
}
